import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  container: {
    textAlign: "center",
    paddingTop: "1rem",
    "@media (min-width: 412px)": {
      paddingLeft: "1rem"
    }
  },
  title: {
    fontWeight: "bold"
  }
});

const ContactTab = ({
  classes,
  name,
  phonenumber,
  salesemail,
  supportemail,
  address,
  className,
  linkstyle
}) => (
  <div className={`${classes.container} ${className}`}>
    <div className={classes.title}>{name}</div>
    <br />
    {phonenumber ? <div className={classes.child}>{phonenumber}</div> : null}
    {supportemail ? (
      <div>
        <OutboundLink
          to={`mailto:${supportemail}`}
          className={linkstyle}
          eventLabel="Support email"
        >
          {supportemail}
        </OutboundLink>
      </div>
    ) : null}
    {salesemail ? (
      <div>
        <OutboundLink
          to={`mailto:${salesemail}`}
          className={linkstyle}
          eventLabel="Sales email - footer"
        >
          {salesemail}
        </OutboundLink>
      </div>
    ) : null}
    <br />
    <div>
      {address.map(i => (
        <div key={i}>{i}</div>
      ))}
    </div>
  </div>
);

ContactTab.propTypes = {
  classes: PropTypes.object,
  name: PropTypes.string.isRequired,
  phonenumber: PropTypes.string,
  salesemail: PropTypes.string,
  supportemail: PropTypes.string,
  address: PropTypes.array,
  className: PropTypes.string,
  linkstyle: PropTypes.string
};

export default injectSheet(styles)(ContactTab);



// WEBPACK FOOTER //
// ./src/components/Footer/ContactTab.jsx